module.exports = __webpack_public_path__ + "static/img/about_03.9698888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/about_03.png
// module id = 3GEp
// module chunks = 34